module.exports = __webpack_public_path__ + "assets/img/img-welfare-02.76258b1e.jpg";